import type { paths } from '@orlikfy/api-interfaces';

export type { NotificationPreferenceCategoryResponseDto } from '@orlikfy/api-interfaces';

// GET /notifications/preferences
export const GET_NOTIFICATION_PREFERENCES_PATH = '/notifications/preferences' as const satisfies keyof paths;
type GetNotificationPreferencesOperation = paths[typeof GET_NOTIFICATION_PREFERENCES_PATH]['get'];
export type GetNotificationPreferencesResponse =
  GetNotificationPreferencesOperation['responses'][200]['content']['application/json'];

// PATCH /notifications/preferences/{category}
export const TOGGLE_NOTIFICATION_PREFERENCE_PATH =
  '/notifications/preferences/{category}' as const satisfies keyof paths;
type ToggleNotificationPreferenceOperation = paths[typeof TOGGLE_NOTIFICATION_PREFERENCE_PATH]['patch'];
export type ToggleNotificationPreferenceBody =
  ToggleNotificationPreferenceOperation['requestBody']['content']['application/json'];
export type ToggleNotificationPreferencePathParams = ToggleNotificationPreferenceOperation['parameters']['path'];
export type ToggleNotificationPreferenceResponse =
  ToggleNotificationPreferenceOperation['responses'][200]['content']['application/json'];
